export default {
    computed: {
        isAuthorized: {
            set(val) {
                this.$store.state.isAuthorized = val;
            },
            get() {
                return this.$store.state.isAuthorized;
            }
        },
        user: {
            set(val) {
                this.$store.state.user = val;
            },
            get() {
                return this.$store.state.user;
            }
        }
    }
};
